// extracted by mini-css-extract-plugin
export var container = "_uf-0";
export var table = "_uf-2";
export var tableWrapper = "_uf-1";